import { Button } from "@chakra-ui/react";
import { FC } from "react";
import { useNavigate } from "react-router";

import { getLoginLogoutUrl } from "@/api/api-configuration";

import { useUser } from "../../../providers/auth-provider";

export const LoginOrBackButton: FC = () => {
  const { loginUrl } = useUser();
  const navigate = useNavigate();
  return (
    <Button
      w="fit-content"
      variant="primary"
      onClick={() =>
        loginUrl ? window.location.replace(getLoginLogoutUrl(loginUrl)) : navigate("/")
      }
    >
      {loginUrl ? "Inloggen" : "Naar BROSTAR"}
    </Button>
  );
};
